// extracted by mini-css-extract-plugin
module.exports = {"scrim":"Scrim_scrim__UirFK","active":"Scrim_active__1TL0n","inactive":"Scrim_inactive__YbOda"};